/* Svensk katalog for locale-investment-resolution.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'investments.documentNonPostingResolved': 'Utredd som kontrolluppgift',
  'investments.documentExistingEventResolved': 'Kopplad till registrerad händelse',
  'investments.resolutionTitle': 'Utred dokumentraden',
  'investments.resolutionIntro': 'Välj bara en avslutning när originaldokumentet och investeringsregistret dokumenterar vad raden representerar. Utredningen skapar ingen kontering.',
  'investments.resolutionChoice': 'Vad representerar raden?',
  'investments.resolutionType.non_posting_reference': 'Kontroll- eller jämförelseuppgift – ingen egen transaktion',
  'investments.resolutionType.existing_event': 'Redan registrerad som en annan investeringshändelse',
  'investments.resolutionExistingEvent': 'Registrerad händelse',
  'investments.resolutionNote': 'Kontrollanteckning och dokumenterad motivering',
  'investments.resolutionNoPostingWarning': 'Detta avslutar raden utan kontering. Använd valet bara när källan visar att beloppet är kontrollinformation och inte en självständig ekonomisk händelse.',
  'investments.resolutionUnsupportedHelp': 'Utdelning i fondandelar och andra händelser som ändrar antal eller anskaffningsvärde utan kontantavräkning stöds inte av den här utredningen. Låt raden stå öppen tills händelsen kan hanteras separat.',
  'investments.resolutionSave': 'Spara utredning',
  'investments.resolutionSaved': 'Dokumenterad utredning',
  'investments.resolutionLinkedEvent': 'Kopplad händelse',
  'investments.resolutionReopenNote': 'Motivering för ny genomgång',
  'investments.resolutionReopen': 'Öppna utredningen igen',
});
